import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFirestoreDocument } from 'angularfire2/firestore';
import { DataOrder, OrderPoints } from 'src/app/interfaces/orderPoints';
import { Order } from '../../interfaces/order.interface';
import { DataOrderClient, Client } from '../../interfaces/orderPoints';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { resolve } from 'url';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  constructor(
		private http: HttpClient,
		private firebase: AngularFirestore
  ) { }

  // Variable para obtener el país
  private country = localStorage.getItem('countryCode');

  // Conexión para obtener las cuentas clientes por país
  private reportByDate = this.firebase.collection('accounts', ref => ref
    .where('current_country', '==', this.country)
  );

  // Conexión para obtener cuenta por id
  conectionById(id: string): AngularFirestoreDocument {
    return this.firebase.collection('accounts').doc(id);
  }

  private pointsRef = (start: any, end: any) => {
    return this.firebase.collection('orders', ref => ref
      .where('countryCode', '==', this.country)
      .where('status', '==', 'delivered')
      .where('added_date', '>=', start)
      .where('added_date', '<=', end)
    );
  }

  // Obtenemos cuentas inactivas
  async getInactiveUsers() {
    const inactiveAccounts = [];

    await this.reportByDate.get().toPromise().then(
      snap => snap.forEach(snapChild => {
        inactiveAccounts.push({
          id: snapChild.id,
          ...snapChild.data()
        })
      })
    );

    return inactiveAccounts;
  }

  // Obtener ordenes por fechas
  async getTimeOrders(start: any, end: any): Promise<DataOrderClient[]>{
    const totalOrders: any = [];

    await this.firebase.collection('orders', ref => ref
      .where('countryCode', '==', this.country)
      .where('added_date', '>=', start)
      .where('added_date', '<=', end)
    ).get().toPromise().then(
      orders => orders.forEach( (order) => {
        totalOrders.push(order.data())
      })
    );
    
    const data = await this.getDataClient(totalOrders);
    return data;
  }
  
  // Obtenemos ordenes pagadas con puntos
  async getOrdersPoints(start: any, end: any): Promise<OrderPoints[]> {
    let orders = [];
    const ordersTemp = [];
    const ref = this.pointsRef(start, end);

    // Obtenemos toda la data y filtramos solo pagos con puntos
    await ref.get().toPromise().then(
      snap => snap.forEach(snapChild => {
        // //console.log(snapChild)
        const order = snapChild.data();
        if (this.extractOnlyClub(order as DataOrder)) ordersTemp.push(order)
      })
    );

    // Agregamos a ordenes la data de cliente
    await this.getDataClient(ordersTemp).then(
      response => orders = response
    );

    return orders
  }

  // Filtra las ordenes pagadas con puntos
  extractOnlyClub(order: DataOrder): boolean {
    let isClub: boolean = false;
    order.bricks.forEach(
      element => isClub = element.type == 'club' ? true : false
    );
    return isClub;
  }

  // Obtiene data de cliente y agrega a orden
  async getDataClient(orders: DataOrder[]) {
    let ordersData = [];

    for await (const order of orders) {
      await this.conectionById(order.account).get().toPromise().then(
        response => {
          ordersData.push({
            client: response.data(),
            dataOrder: order
          });
        }
      )
    }
    return ordersData;
  }

  //Obtiene la data de la tabla desde un servicio
  async getDataReports ( token:string, countryCode:string, storeKey:string, dateInit:string, dateEnd:string) {
	return new Promise(async (resolve, reject)=>{
		// Crea el cuerpo de la peticion
		let url = 'https://reports.barlleno.app/reports/get/listorders/store'
		const httpOptions = {
			headers: new HttpHeaders({
				'Access-Control-Allow-Origin': 'origin',
				'application': 'x-www-form-urlencoded',
				'Content-type': 'application/json',
				'Access-Control-Allow-Credentials': 'true',
				'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, Origin, Cache-Control, Pragma, Authorization, Accept, Accept-Encoding',
				'Access-Control-Allow-Methods': 'PUT, POST, GET, OPTIONS, DELETE'
			})
		};
		let body = {
			"token": token,
			"data": {
				"storeKey": storeKey,
				"countryCode":countryCode,
				"dateInit": dateInit,
				"dateEnd": dateEnd
			}
		}

		//Realiza la peticion
		this.http.post(url, body, httpOptions)
		.subscribe((response: any) => {
		  resolve( {
			data: response.data,
			error: true
		  });

		}, err => {
		  console.log(err.message);
		  console.log(err.response);
		  resolve({
			data: undefined,
			error: true
		  });
  
		  return {
			data: undefined,
			error: true
		  };
		})
	})

  }

}
